import { Vector3 } from 'three';
import { PHYSICS } from '../../config/settings';
import { MoveContext, MovementState } from './MovementState';

const UP = new Vector3(0, 1, 0);

/**
 * Clinging to a wall: gravity is off, WASD moves along the wall plane
 * (W/S up·down, A/D sideways) and a small inward velocity keeps the player
 * pinned. Leaping off and mantling over the top are handled by the controller.
 */
export class ClimbingState implements MovementState {
  readonly name = 'climbing';
  private readonly side = new Vector3();
  private readonly wish = new Vector3();

  update({ player, input }: MoveContext): void {
    const normal = player.wallNormal;
    this.side.crossVectors(UP, normal).normalize();

    this.wish.set(0, 0, 0);
    if (input.isDown('KeyW')) this.wish.add(UP);
    if (input.isDown('KeyS')) this.wish.addScaledVector(UP, -1);
    if (input.isDown('KeyD')) this.wish.add(this.side);
    if (input.isDown('KeyA')) this.wish.sub(this.side);
    if (this.wish.lengthSq() > 0) this.wish.normalize().multiplyScalar(PHYSICS.CLIMB_SPEED);

    player.velocity.copy(this.wish).addScaledVector(normal, -PHYSICS.WALL_STICK);
  }
}
